import React from "react";
import Lottie from "react-lottie";
import animationData from "assets/images/icon.json";
import styles from './SuccessIcon.module.css'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const SuccessIcon = ({height, width}) => {
  return (
    <div>
      <Lottie options={defaultOptions} height={height || '100px'} width={width || '100px'} />
    </div>
  );
};

export default SuccessIcon;
